import { Moon02Icon, Sun03Icon, type TerraIcon } from '@terra/ui-icons';
import { THEME_CHOICE, type ThemeChoice } from './constants';

export type ThemeOption = {
  value: ThemeChoice;
  labelKey: 'appearanceLight' | 'appearanceDark' | 'appearanceSystem';
  icon: TerraIcon;
};
export const THEME_OPTIONS: ThemeOption[] = [
  { value: THEME_CHOICE.LIGHT, labelKey: 'appearanceLight', icon: Sun03Icon },
  { value: THEME_CHOICE.DARK, labelKey: 'appearanceDark', icon: Moon02Icon },
  {
    value: THEME_CHOICE.SYSTEM,
    labelKey: 'appearanceSystem',
    icon: Sun03Icon,
  },
];
